// extracted by mini-css-extract-plugin
module.exports = {"top_bg":"styles_top_bg__3TcbI"};